import axios from '@/http/axios'

export function loginUser (credentials) {
  if (!credentials.super_admin) return axios({
    url: 'v1/auth/login',
    data: {
      email: credentials.email,
      code: credentials.otpCode
    },
    method: 'post'
  })

  else return axios({
    url: 'v1/auth/login',
    data: {
      super_admin: credentials.super_admin,
      phone_number: credentials.phoneNumber,
      token: credentials.token
    },
    method: 'post'
  })

}

export function sendOTPCode (email) {
  return axios({
    url: 'v1/auth/send-otp',
    data: {
      email
    },
    method: 'post'
  })
}

export function resendOTPCode (email, voice) {
  return axios({
    url: 'v1/auth/send-otp',
    data: {
      email,
      voice
    },
    method: 'post'
  })
}

export function logoutUser () {
  return axios({
    url: 'v1/logout',
    method: 'post'
  })
}
